{
  "$id": "module://department",
  "$schema": "wealthlane://schemas/domain",
  "title": "Department",
  "description": "Customer department field catalog",
  "type": "object",
  "properties": {
    "name": {
      "type": "string",
      "title": "Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "maxLength": 1000,
      "adapterProps": { "rows": 5 }
    }
  }
}
